import React from 'react';

import Input from '../forms/input/input.jsx';

const Cpt = ({err, onChange, defaultValue, placeholder}) => (
    <Input
        err={err}
        placeholder={placeholder || "请输入用户名"}
        onChange={onChange}
        defaultValue={defaultValue}
        verify={v => {
            if (!v.length) {
                throw new Error('请输入用户名');
            } else if (v.length < 2 || v.length > 32) {
                throw new Error('用户名要求2-11个字符长度');
            } else if (!/^(?:[\u4e00-\u9fa5a-zA-Z\d]{2,32})$/.test(v)) {
                throw new Error('用户名只能为中文、字母、数字组成');
            }
            return true;
        }}
    />
);

export default Cpt;
